import { ChangeDetectionStrategy, Component, Inject, OnDestroy, Optional } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { NotificationInitiatorService } from './notification-initiator.service';
import { NNotificationModal } from './notification.interfaces';
@DfModal({
    id: NNotificationModal.id,
    position: 'right',
    config: sizeName => ({
        closeOnNavigation: false,
        transformOptions: `translate3d(100%, 0px, 0px)`,
        modalClass: 'p-a-0',
        position: {
            top: '10em',
            right: '10em'
        },
        transitionOptions: '500ms ease-in-out',
        width: '20em'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.wait,
    initiators: [NotificationInitiatorService],
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    templateUrl: './notification.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationModalComponent implements OnDestroy {
    /**
     * Close timeout id
     */
    private timeoutId?: number;
    /**
     * Close notification
     */
    constructor(private modalRef: ModalRef<NotificationModalComponent>,
    @Optional() @Inject(MODAL_DATA)
    readonly data: NNotificationModal.IModalData, timeoutService: TimeoutService) {
        timeoutService.setTimeout(() => {
            this.close();
        }, 5000);
    }
    /**
     * Close notification
     */
    close() {
        this.modalRef.close();
    }
    /**
     * Cleanup
     */
    ngOnDestroy() {
        clearTimeout(this.timeoutId);
    }
}
